export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        iconClass: 'fa-dashboard',
      },
    },
    {
      name: 'my-rents',
      displayName: 'menu.rents',
      meta: {
        iconClass: 'fa-calendar',
      },
    },
    {
      name: 'my-users',
      displayName: 'menu.users',
      meta: {
        iconClass: 'fa-users',
      },
    },
    {
      name: 'campaigns',
      displayName: 'menu.campaigns',
      meta: {
        iconClass: 'fa-tag',
      },
      disabled: true,
      children: [
        {
          name: 'my-campaigns',
          displayName: 'menu.myCampaigns',
        },
        {
          name: 'add-campaign',
          displayName: 'menu.addCampaign',
        },
      ],
    },
    {
      name: 'vehicles',
      displayName: 'menu.vehicles',
      meta: {
        iconClass: 'fa-car',
      },
      disabled: true,
      children: [
        {
          name: 'my-vehicles',
          displayName: 'menu.myVehicles',
        },
        {
          name: 'add-vehicle',
          displayName: 'menu.addVehicle',
        },
      ],
    },
    {
      name: 'vehicle-segments',
      displayName: 'menu.vehicleSegments',
      meta: {
        iconClass: 'fa-bookmark',
      },
      disabled: true,
      children: [
        {
          name: 'my-vehicle-segments',
          displayName: 'menu.myVehicleSegments',
        },
        {
          name: 'add-vehicle-segment',
          displayName: 'menu.addVehicleSegment',
        },
      ],
    },
    {
      name: 'my-vehicle-extras',
      displayName: 'menu.vehicleExtras',
      meta: {
        iconClass: 'fa-cart-plus',
      },
    },
    {
      name: 'regions',
      displayName: 'menu.regions',
      meta: {
        iconClass: 'fa-map',
      },
      disabled: true,
      children: [
        {
          name: 'my-regions',
          displayName: 'menu.myRegions',
        },
        {
          name: 'add-region',
          displayName: 'menu.addRegion',
        },
      ],
    },
    {
      name: 'my-settings',
      displayName: 'menu.settings',
      meta: {
        iconClass: 'fa-cog',
      },
    }
  ],
}
